module.exports = __webpack_public_path__ + "static/media/lambda.ba76b02e.svg";